import { render } from "./SkillBox.vue?vue&type=template&id=079f15c1"
import script from "./SkillBox.vue?vue&type=script&lang=js"
export * from "./SkillBox.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/adriengeoorge.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__